import { render, staticRenderFns } from "./DeadChildsModal.vue?vue&type=template&id=96e1c88a"
import script from "./DeadChildsModal.vue?vue&type=script&lang=js"
export * from "./DeadChildsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports